module.exports = __webpack_public_path__ + "static/media/amusement.857d8e49.mp4";